/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Utils } from "Utils/utils";
import makeApi, { URLS } from "Utils/apiURL";
import { userDetail } from "Stores/userDetail";

const Authenticate = props => {
  const whiteLabel = async token => {
    try {
      const config = {
        url: URLS.whiteLable,
        method: "GET"
      };
      // debugger;
      let res = await makeApi(config);
      let { data = {} } = res || {};
      console.log(JSON.stringify(data, null, 2));
      userDetail.setUserInfo();
    } catch (err) {
      console.error(err);
      // setLoader(false);
      // setErrMsg("Something went wrong");
    }
  };

  const authenticate = async authCode => {
    try {
      let response = await makeApi({
        url: `${URLS.authenticate}?authCode=${authCode}`,
        method: "GET"
      });
      debugger;
      if (response?.data?.success === true) {
        // Update required logic
        await whiteLabel();
        console.log("sadasdas");
        props.history.push("/dashboard");
      } else {
        props.history.push("/login");
      }
    } catch (err) {
      console.error("Authentication failed:", err);
      props.history.push("/login");
    }
  };

  useEffect(() => {
    const query = Utils.getQueryParams(props.location.search);
    const authCode = query.get("auth-code");

    if (authCode) {
      authenticate(authCode);
    } else {
      props.history.push("/login");
    }
  }, [props.location.search, props.history]);

  return (
    <div className="auth-page">
      <h2>Authenticating...</h2>
      <p>Please wait while we log you in.</p>
    </div>
  );
};

export default withRouter(Authenticate);
